import { useState } from "react";
import { Card, Button } from "@postenbring/hedwig-react";
import { Icon } from "../../../shared/icon/icon";
import "./ImageIllustration.scss";

export const ImageIllustration = ({
    imageUrl,
    imageAltText,
    isIllustration,
    focalPointStyle,
    isAnimatedGif,
    pauseImageUrl,
    pauseAnimationLabel,
    playAnimationLabel,
}) => {
    const [isPaused, setIsPaused] = useState(false);
    const canToggleAnimation = isAnimatedGif && pauseImageUrl;

    return (
        <Card.Media>
            <Card.MediaImg
                style={focalPointStyle}
                alt={!isIllustration ? imageAltText : ""}
                src={canToggleAnimation && isPaused ? pauseImageUrl : imageUrl}
                variant={isIllustration ? "scale" : "crop"}
            />
            {canToggleAnimation && (
                <Button
                    variant="secondary"
                    size="small"
                    icon
                    className="kp-card-gif-control"
                    aria-label={isPaused ? playAnimationLabel : pauseAnimationLabel}
                    title={isPaused ? playAnimationLabel : pauseAnimationLabel}
                    onClick={(event) => {
                        event.stopPropagation();
                        setIsPaused((paused) => !paused);
                    }}
                >
                    <Icon variant={isPaused ? "play" : "pause"} />
                </Button>
            )}
        </Card.Media>
    );
};
